<!-- <header class="flex justify-between items-center px-6 w-16 h-16 w-full border-b shadow-sm"> -->
  <mat-toolbar class="flex justify-between  border-b shadow-sm">
    <div class="flex gap-3 items-center">
      <!-- @if(parent.isMobile()){ -->
        <button mat-icon-button (click)="side_drawer.toggle()" class="cursor-pointer"><mat-icon>menu</mat-icon></button>
      <!-- } -->
      <mat-icon class="eru-icon" svgIcon="eru-logo"></mat-icon>
      <!-- <img src="../../../assets/images/common/eru.svg"
                    alt="eru" class="object-contain h-8" /> -->
                    <!-- {{configStore.requestHeader()?.serviceAccess}} -->
    </div>
    <nav class="flex gap-4 items-center text-sm">
        <a href="/console" class="text-sm font-semibold" title="Back to the console">Open console</a>
        <div class="w-px h-8"></div>
        <div class="flex gap-3 items-center">
            <span [mat-menu-trigger-for]="profileMenu" class="mouse-pointer text-sm font-medium">{{userName()}}</span>
            <mat-menu #profileMenu="matMenu">
              <button mat-menu-item class="mouse-pointer ml-2" (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="themeMenu" class="mouse-pointer ml-2">
                <mat-icon>{{ themeService.selectedTheme()?.icon }}</mat-icon>
                <span>Change Theme</span>
              </button>              
              @if(configStore.requestHeader() && configStore.requestHeader()?.userId != ''){
                <mat-divider></mat-divider>
                <button mat-menu-item class="mouse-pointer ml-2" (click)="openSwitchUserDialog()">
                  <mat-icon>person</mat-icon>
                  <span>{{configStore.requestHeader()?.userId}}</span>
                </button>
              }
            </mat-menu>
           
            <mat-menu #themeMenu="matMenu">
                @for (theme of themeService.getThemes(); track theme.name) {
                <button
                  [class.selected-theme]="
                    themeService.selectedTheme()?.name === theme.name
                  "
                  mat-menu-item
                  (click)="themeService.setTheme(theme.name)"
                >
                  <mat-icon>{{ theme.icon }}</mat-icon>
                  <span>{{ theme.name | titlecase }}</span>
                </button>
                }
            </mat-menu>
        </div>
    </nav>
  </mat-toolbar>